<template>
  <div :class="template">
    <b-overlay
      :show="!permission"
      rounded="lg"
      spinner-variant="customer"
      id="app"
      :style="cssProps"
    >
      <template v-if="$auth.check()">
        <div class="bg-global">
          <NavBar />
          <Header />
          <div class="pt-3">
            <router-view />
          </div>
          <Footer />
        </div>
      </template>
      <router-view v-else></router-view>
    </b-overlay>
  </div>
</template>

<script>
import NavBar from "./views/private/components/NavBar.vue";
import Header from "./views/private/components/Header.vue";
import Footer from "./views/private/components/Footer.vue";
export default {
  name: "App",
  data() {
    return {
      user: null,
      asset_id: null,
      apartments: [],
      tab_index: 0,
      selectedApartment: null,
    };
  },
  components: { NavBar, Header, Footer },
  methods: {
    logout() {
      this.$auth.logout({
        redirect: `/app/${this.$route.params.customer}/login`,
        success: function (msg) {
          console.error("LOGIN:", msg);
        },
      });
    },
  },
  watch: {
    "$route.params.customer": {
      handler: function () {
        this.$store.commit("setCustomer", this.$route.params.customer);
        this.$store.commit("setCustomerData");
        if (this.$auth.check()) this.user = this.$auth.user();
      },
      immediate: true,
    },
    customerId: {
      handler: function () {
        if (this.customerId && this.user) {
          if (!(this.user.customer_id == this.customerId)) {
            this.logout();
          }
        }
      },
      immediate: true,
    },
  },
  computed: {
    cssProps() {
      return {
        "--color": `linear-gradient(90deg, ${this.color}, ${this.colorB})`,
        "--color-a": this.color,
        "--color-background": `linear-gradient(90deg, ${this.colorBackground}, ${this.colorBackgroundB})`,
        "--color-background-a": this.colorBackground,
        "--color-btn": `linear-gradient(90deg, ${this.colorBtn}, ${this.colorBtnB})`,
        "--color-btn-a": this.colorBtn,
        "--color-btn-text": this.colorBtnText,
        "--color-menu": `linear-gradient(90deg, ${this.colorMenu}, ${this.colorMenuB})`,
        "--color-menu-a": this.colorMenu,
        "--color-menu-text": this.colorMenuText,
        "--color-footer": `linear-gradient(90deg, ${this.colorFooter}, ${this.colorFooterB})`,
        "--color-footer-a": this.colorFooter,
        "--color-footer-text": this.colorFooterText,
        "--color-header": `linear-gradient(90deg, ${this.colorHeader}, ${this.colorHeaderB})`,
        "--color-header-a": this.colorHeader,
        "--color-text-header": this.colorTextHeader,
        "--color-var": `linear-gradient(90deg, ${this.colorVar}, ${this.colorVarB})`,
        "--color-var-text": this.colorVarText,
        "--color-var-a": this.colorVar,
        "--color-text": this.colorText,
        "--color-login-btn": `linear-gradient(90deg, ${this.colorLoginBtn}, ${this.colorLoginBtnB})`,
        "--color-login-btn-a": this.colorLoginBtn,
        "--color-login-btn-text": this.colorLoginBtnText,
      };
    },
    template() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.template
        : "default";
    },
    color() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.color
        : null;
    },
    colorBackground() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.color_background
        : null;
    },
    colorBtn() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.color_btn
        : null;
    },
    colorBtnText() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.color_btn_text
        : null;
    },
    colorFooter() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.color_footer
        : null;
    },
    colorFooterText() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.color_footer_text
        : null;
    },
    colorLoginBtn() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.color_login_btn
        : null;
    },
    colorLoginBtnText() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.color_login_btn_text
        : null;
    },
    colorMenu() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.color_menu
        : null;
    },
    colorMenuText() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.color_menu_text
        : null;
    },
    colorText() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.color_text
        : null;
    },
    colorHeader() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.color_header
        : null;
    },
    colorTextHeader() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.color_text_header
        : null;
    },
    colorVar() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.color_var
        : null;
    },
    colorB() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.color_b
        : null;
    },
    colorBackgroundB() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.color_background_b
        : null;
    },
    colorBtnB() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.color_btn_b
        : null;
    },
    colorFooterB() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.color_footer_b
        : null;
    },
    colorLoginBtnB() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.color_login_btn_b
        : null;
    },
    colorMenuB() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.color_menu_b
        : null;
    },
    colorHeaderB() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.color_header_b
        : null;
    },
    colorVarB() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.color_var_b
        : null;
    },
    colorVarText() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.color_var_text
        : null;
    },

    permission() {
      if (this.$store.getters.getCustomerData) {
        return this.$store.getters.getCustomerData.products.find(
          (product) => product.name == "Sala de Ventas Virtual"
        )
          ? true
          : false;
      } else {
        return false;
      }
    },
    customerId() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.customer_id
        : null;
    },
  },
};
</script>
<style lang="scss">
@import "assets/sass/main";
.default {
  font-family: "Lato", sans-serif !important;
  @import "assets/sass/templates/default";
}
.cuadrado {
  font-family: "Montserrat", sans-serif !important;
  @import "assets/sass/templates/cuadrado";
}
.redondo {
  font-family: "Lato", sans-serif !important;
  @import "assets/sass/templates/redondo";
}
</style>
